import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Inswing',  label: 'Inswing'  },
  { value: 'Outswing', label: 'Outswing' },
];

const DEFAULT = 'Inswing';

const Swing = ({ value = { value: '', label: '' }, onChange, disabled = false, onSwingChange }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    // notify panel so it can show/hide DecorativeTips
    onSwingChange?.(v);
  };

  return (
    <div className="a-container">
      <label htmlFor="SdSwing">Swing</label>
      <select id="SdSwing" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Swing;
